module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAP1BMVEUAAACAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAO/LeHAAAAFHRSTlMAcLBQ0C+QEOAHmjxheErexzgbGgZDqNEAAABuSURBVCjP7clBDoQgEETREoGZBnRGrfuf1ZhgFG0Sli78q588NDcwN6jsd/Yqi8sJioJVC5lZKXPs1CIak59BUWTC0Yffkjv6Gye7ALNNFTbsgZ7m5cdw4AREhgqL296JwhzdOXPhawXjf+MRDa2Fmw9AWA7nbQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/ic_address_del.png
// module id = Vd6y
// module chunks = 21